import React from "react";

const SvgNotifikace = props => (
  <svg id="notif-icon" viewBox="0 0 200 200" {...props}>
    <g data-name="Horn\xED menu + Footer">
      <path d="M157.64 136.2l-.78-5c-1.25-7.94-3.55-22.63-3.61-23-1.25-7.79-2.32-14.28-3.1-18.7v-.15c-2.59-20.7-15.09-37.83-32.65-44.79a17.6 17.6 0 00-34.94.07c-17.65 7-30.17 24.2-32.71 45-.85 4.89-1.95 11.48-3.08 18.55-.08.52-4.36 27.78-4.39 28a8 8 0 00-.09 1.17 8.8 8.8 0 008.78 8.8H149a8.79 8.79 0 008.76-8.8 8 8 0 00-.12-1.15zm-67.29-89a4.33 4.33 0 00-.06-.58 9.72 9.72 0 0119.44-.18 4.24 4.24 0 00-.08.71 3.94 3.94 0 002.7 3.93c16.08 5.3 27.56 20.3 30 39.12v.53c.78 4.44 1.86 10.91 3.11 18.72.07.47 4.35 27.77 4.38 27.92a.9.9 0 01-.89.93h-97.9a.87.87 0 01-.62-.26 1 1 0 01-.29-.64l.74-4.73c1.25-8 3.58-22.82 3.64-23.22 1.14-7.13 2.25-13.75 3.11-18.65v-.46c2.36-18.84 13.84-33.86 30-39.19a4 4 0 002.72-3.94zM120.38 151.53a4 4 0 00-5.25 1.88 16.72 16.72 0 01-30.42-.41 3.92 3.92 0 00-2.19-2.08 3.93 3.93 0 00-5.09 2.25 3.93 3.93 0 00.07 3 24.6 24.6 0 0044.75.58 4 4 0 00-1.87-5.22z" />
    </g>
  </svg>
);

export default SvgNotifikace;

